type ConfigEntry = {
  key: string;
  value: string | undefined;
  fallback?: string;
};

const configValidation = ({ key, value, fallback }: ConfigEntry) => {
  if (value === undefined) {
    if (fallback !== undefined) {
      console.warn(`[WARN] Config ${key} is missing. Using fallback value: ${fallback}`);
      return fallback;
    }
    console.error(`[ERROR] Missing required configuration ${key}`);
    return '';
  }

  return value;
};

export const ENV = configValidation({ key: 'ENV', value: process.env.REACT_APP_ENV });

export const IS_PROD = ENV === 'PROD';

export const TRACKING_URL = configValidation({
  key: 'TRACKING_URL',
  value: process.env.REACT_APP_TRACKING_URL,
});

export const API_URL = configValidation({
  key: 'API_URL',
  value: process.env.REACT_APP_API_URL,
});
